import type { Variants } from "framer-motion"

import {
    MOTION_DURATION_S,
    MOTION_EASE,
    MOTION_SPRING,
} from "~components/shared/motion/motion-tokens"

// User messages "pop" in — they're user-authored, discrete, and feel
// satisfying when they lift into place.
export const USER_MESSAGE_ENTER_VARIANTS: Variants = {
    initial: { opacity: 0, y: 8, scale: 0.98 },
    animate: {
        opacity: 1,
        y: 0,
        scale: 1,
        transition: MOTION_SPRING.snappy,
    },
    exit: {
        opacity: 0,
        y: -4,
        transition: {
            duration: MOTION_DURATION_S.quick,
            ease: MOTION_EASE.accel,
        },
    },
}
// AI messages fade in only — no scale or translate. Streaming tokens extend
// the text in place, so we deliberately avoid any transform that would make
// the bubble appear to resize or inflate.
export const AI_MESSAGE_ENTER_VARIANTS: Variants = {
    initial: { opacity: 0 },
    animate: {
        opacity: 1,
        transition: {
            duration: MOTION_DURATION_S.base,
            ease: MOTION_EASE.decel,
        },
    },
    exit: {
        opacity: 0,
        transition: {
            duration: MOTION_DURATION_S.quick,
            ease: MOTION_EASE.accel,
        },
    },
}
export const PANEL_EMERGE_VARIANTS: Variants = {
    initial: { opacity: 0, scale: 0.92, y: 12 },
    animate: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: MOTION_SPRING.snappy,
    },
    exit: {
        opacity: 0,
        scale: 0.94,
        y: 8,
        transition: {
            duration: MOTION_DURATION_S.quick,
            ease: MOTION_EASE.accel,
        },
    },
}
